/* =====================================================================
   RC v4 · Ficha del cepillo alaciador igual de limpia que Lady Pipa (LAND, 21-oct-2026)
   Solo la carga la ficha del cepillo (snippets/rc-compra.liquid). Sin dependencias.
   - Bucle del LED en la galería: se pide al terminar de cargar, sin audio, y se pausa si no se ve.
   - Ligas que abren su desplegable y fecha de entrega estimada.
   - El color elegido en el circulito junto al nombre y, en compu, su foto como la grande de la galería.
   - Flechas de «También te puede gustar» en compu.
   - Barra fija (celular) y encabezado transparente solo encima de la galería: blanco en cuanto deja de estar encima,
     o si la foto de enfrente es de producto (fondo blanco).
   - «Míralo en acción»: los videos solo arrancan con clic, uno a la vez (clips).
   - Se queda el módulo de antes y después (rc-antes, apagado) por si se vuelve a prender.
   Respeta "reducir movimiento" y el ahorro de datos.
   ===================================================================== */
(function(){
  if (window.__rlInit) return; window.__rlInit = true;
  var html = document.documentElement;
  html.classList.add('rl-js', 'rl-page');

  var quieto = false, ahorro = false;
  try {
    quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    ahorro = !!(navigator.connection && navigator.connection.saveData);
  } catch (e) {}
  var hayIO = 'IntersectionObserver' in window;

  function $(s, r){ return (r || document).querySelector(s); }
  function $$(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }
  function play(v){ try { var p = v.play(); if (p && p.catch) p.catch(function(){}); } catch (e) {} }

  /* ---------- 1. Bucle de la galería ---------- */
  function hero(){
    var v = $('[data-rl-hero]'); if (!v || v.getAttribute('data-rl-ok')) return;
    v.setAttribute('data-rl-ok', '1');
    if (quieto || ahorro) return;
    var slide = v.parentNode, visible = false, listo = false;
    function muestra(){ slide.classList.add('is-play'); }
    v.addEventListener('playing', function(){
      if (slide.classList.contains('is-play')) return;
      if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(function(){ muestra(); }); else muestra();
    });
    function arranca(){
      if (listo) return; listo = true;
      v.src = v.getAttribute('data-src'); v.preload = 'auto';
      if (visible) play(v);
    }
    if (hayIO){
      new IntersectionObserver(function(en){ en.forEach(function(x){
        visible = x.isIntersecting && x.intersectionRatio > 0.5;
        if (visible && !listo) arranca();
        if (!listo) return;
        if (visible) play(v); else if (!v.paused) v.pause();
      }); }, {threshold: [0, 0.5, 1]}).observe(slide);
    } else { visible = true; }
    if (document.readyState === 'complete') setTimeout(arranca, 400);
    else window.addEventListener('load', function(){ setTimeout(arranca, 400); });
  }

  /* ---------- 2. Ligas que abren su desplegable ---------- */
  function ligas(){
    document.addEventListener('click', function(e){
      var a = e.target.closest ? e.target.closest('[data-rl-open]') : null; if (!a) return;
      var d = document.getElementById('rl-acc-' + a.getAttribute('data-rl-open')); if (!d) return;
      e.preventDefault();
      d.open = true;
      var hd = $('#header-group .azh'), off = (hd ? hd.offsetHeight : 64) + 16;
      var y = d.getBoundingClientRect().top + window.pageYOffset - off;
      window.scrollTo({top: Math.max(0, y), behavior: quieto ? 'auto' : 'smooth'});
    });
  }

  /* ---------- 3. Fecha de entrega estimada (1 a 3 días hábiles, como el resto de la tienda) ---------- */
  function entrega(){
    var el = $('[data-rl-eta]'); if (!el) return;
    var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function habiles(n){ var x = new Date(), c = 0; while (c < n){ x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) c++; } return x; }
    var a = habiles(1), b = habiles(3);
    el.textContent = DIAS[a.getDay()] + ' ' + a.getDate() + (a.getMonth() !== b.getMonth() ? ' ' + MESES[a.getMonth()] : '') + ' – ' + DIAS[b.getDay()] + ' ' + b.getDate() + ' ' + MESES[b.getMonth()];
  }

  /* ---------- 4. El color elegido en el circulito junto al nombre ---------- */
  function color(){
    document.addEventListener('click', function(e){
      var b = e.target.closest ? e.target.closest('[data-az-sw]') : null;
      if (!b || !b.closest('.rl-buy')) return;
      var c = b.style.getPropertyValue('--c');
      $$('[data-rl-cdot]').forEach(function(x){ if (c) x.style.setProperty('--c', c); });
      if (!cel()) fotoGrande(b.getAttribute('data-value'));
      else fotoDelColor(b.getAttribute('data-value'));
      setTimeout(galeria, 450);
    });
  }

  /* ---------- 4b. Compu: la galería no es carrusel; la foto del color elegido pasa a ser la grande ----------
     Se reacomoda el orden original (el color primero y el resto como estaba). az.js guarda las fotos por
     elemento, así que en celular el carrusel sigue llegando a la foto correcta aunque cambie el orden. */
  var ordenOriginal = null;
  function idFoto(valor){
    var js = $('.rl-buy [data-az-json]'); if (!js) return null;
    var data = null; try { data = JSON.parse(js.textContent); } catch (e) { return null; }
    var idx = data.colorIdx, vs = data.variants || [];
    for (var i = 0; i < vs.length; i++){ if (vs[i].options[idx] === valor && vs[i].featured_media) return String(vs[i].featured_media.id); }
    return null;
  }
  /* Celular: la foto del color con el que llegó la liga lleva data-media="sel-…" (para que az.js no mueva el carrusel al cargar);
     si la clienta elige ese color a mano, aquí se lleva el carrusel a su foto. Las demás las mueve az.js. */
  function fotoDelColor(valor){
    var track = $('.rl-buy [data-az-track]'), mid = idFoto(valor); if (!track || !mid) return;
    var sl = track.querySelector('[data-rl-mid="' + mid + '"]');
    if (!sl || sl.getAttribute('data-media') === mid) return;
    track.scrollTo({left: sl.offsetLeft - track.firstElementChild.offsetLeft, behavior: quieto ? 'auto' : 'smooth'});
  }
  function fotoGrande(valor){ fotoGrandeMid(idFoto(valor)); }
  function fotoGrandeMid(mid){
    var track = $('.rl-buy [data-az-track]');
    if (!track || !mid) return;
    if (!ordenOriginal) ordenOriginal = [].slice.call(track.children);
    var elegida = null;
    ordenOriginal.forEach(function(sl){ if (sl.getAttribute('data-rl-mid') === mid) elegida = sl; });
    if (!elegida || track.firstElementChild === elegida) return;
    track.appendChild(elegida);
    ordenOriginal.forEach(function(sl){ if (sl !== elegida) track.appendChild(sl); });
    track.insertBefore(elegida, track.firstElementChild);
    var img = elegida.querySelector('img'); if (img){ img.loading = 'eager'; }
    var hd = $('#header-group .azh'), tope = hd ? hd.getBoundingClientRect().bottom : 0;
    var r = elegida.getBoundingClientRect();
    if (r.bottom < tope + 80){ window.scrollTo({top: Math.max(0, r.top + window.pageYOffset - tope - 16), behavior: quieto ? 'auto' : 'smooth'}); }
  }

  /* ---------- 4d. Ficha genérica (snippets/rl-ficha.liquid): variantes sin az.js ----------
     Cualquier opción (color en circulitos u otra en cajas): busca la variante, cambia precio, botón, ?variant=,
     el nombre de la opción, el circulito junto al nombre y la foto (celular: el carrusel va a la foto; compu: pasa a ser la grande). */
  function dinero(c){
    var v = c / 100;
    var s = (Math.round(v * 100) % 100 === 0) ? Math.round(v).toLocaleString('en-US') : v.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return '$' + s;
  }
  function fichaGenerica(){
    var root = $('[data-rl-ficha]'); if (!root || root.getAttribute('data-rl-ok')) return;
    root.setAttribute('data-rl-ok', '1');
    var js = root.querySelector('[data-az-json]'), data = null;
    try { data = JSON.parse(js.textContent); } catch (e) { return; }
    var vs = data.variants || [], colorIdx = data.colorIdx, actual = null;
    vs.forEach(function(v){ if (String(v.id) === String(data.current)) actual = v; });
    if (!actual) actual = vs[0];
    if (!actual) return;
    var elegidas = actual.options.slice();
    function igual(v, s){ for (var i = 0; i < s.length; i++){ if (v.options[i] !== s[i]) return false; } return true; }
    function busca(s){ for (var i = 0; i < vs.length; i++){ if (igual(vs[i], s)) return vs[i]; } return null; }
    function porUna(i, val){
      var r = null;
      for (var k = 0; k < vs.length; k++){ if (vs[k].options[i] === val){ if (vs[k].available) return vs[k]; if (!r) r = vs[k]; } }
      return r;
    }
    function pinta(v){
      actual = v; elegidas = v.options.slice();
      var pr = root.querySelector('[data-rl-price]'); if (pr) pr.textContent = dinero(v.price);
      $$('form.rl-form input[name="id"]', root).forEach(function(x){ x.value = v.id; });
      var b = root.querySelector('[data-az-add]');
      if (b){ b.disabled = !v.available; b.textContent = v.available ? 'Agregar al carrito' : 'Agotado'; }
      var sb = $('[data-rl-stk] [data-rl-add]'); if (sb){ sb.disabled = !v.available; sb.textContent = v.available ? 'Agregar al carrito' : 'Agotado'; }
      $$('.rl-eta', root).forEach(function(x){ x.hidden = !v.available; });
      $$('[data-rl-opt]', root).forEach(function(o){
        var i = +o.getAttribute('data-rl-opt'), on = o.getAttribute('data-value') === v.options[i];
        o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-rl-optname]', root).forEach(function(n){ n.textContent = v.options[+n.getAttribute('data-rl-optname')] || ''; });
      if (colorIdx > -1){
        var cb = null;
        $$('[data-rl-opt="' + colorIdx + '"]', root).forEach(function(o){ if (o.getAttribute('data-value') === v.options[colorIdx]) cb = o; });
        var c = cb ? cb.style.getPropertyValue('--c') : '';
        if (c) $$('[data-rl-cdot]', root).forEach(function(x){ x.style.setProperty('--c', c); });
      }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
      if (v.featured_media){
        var mid = String(v.featured_media.id), track = root.querySelector('[data-az-track]');
        if (!cel()) fotoGrandeMid(mid);
        else if (track){
          var sl = track.querySelector('[data-rl-mid="' + mid + '"]');
          if (sl) track.scrollTo({left: sl.offsetLeft - track.firstElementChild.offsetLeft, behavior: quieto ? 'auto' : 'smooth'});
        }
        setTimeout(galeria, 450);
      }
    }
    root.addEventListener('click', function(e){
      var o = e.target.closest ? e.target.closest('[data-rl-opt]') : null; if (!o) return;
      var i = +o.getAttribute('data-rl-opt'), val = o.getAttribute('data-value');
      var s = elegidas.slice(); s[i] = val;
      var v = busca(s) || porUna(i, val);
      if (v) pinta(v);
    });
  }

  /* ---------- 4e. Color agotado: la barra fija se desactiva y la caja de la fecha se esconde ----------
     Sigue al botón principal (lo cambian az.js en el cepillo y fichaGenerica en las demás) con un MutationObserver. */
  function agotado(){
    var main = $('.rl-buy [data-az-add]'); if (!main || main.getAttribute('data-rl-obs')) return;
    main.setAttribute('data-rl-obs', '1');
    function sigue(){
      var no = !!main.disabled;
      var sb = $('[data-rl-stk] [data-rl-add]');
      if (sb){ sb.disabled = no; sb.textContent = no ? 'Agotado' : 'Agregar al carrito'; }
      $$('.rl-buy .rl-eta').forEach(function(x){ x.hidden = no; });
    }
    if ('MutationObserver' in window) new MutationObserver(sigue).observe(main, {attributes: true, attributeFilter: ['disabled']});
    document.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('[data-az-sw],[data-rl-opt]')) setTimeout(sigue, 60); });
    sigue();
  }

  /* ---------- 4c. «También te puede gustar»: flechas y shift + rueda en compu ----------
     En compu el carrusel no tiene scroll de usuario (overflow hidden): la rueda y el trackpad pasan de largo
     hacia la página. Solo se mueve con las flechas o con shift + rueda (listener pasivo, sin preventDefault). */
  function relacionados(){
    $$('[data-rl-rel-car]').forEach(function(car){
      if (car.getAttribute('data-rl-ok')) return; car.setAttribute('data-rl-ok', '1');
      var box = car.closest('.rl-rel'); if (!box) return;
      var prev = box.querySelector('[data-rl-rel="-1"]'), next = box.querySelector('[data-rl-rel="1"]');
      function paso(){ var it = car.querySelector('.rl-rel__i'); var g = parseFloat(getComputedStyle(car).columnGap) || 16; return it ? (it.getBoundingClientRect().width + g) * 4 : car.clientWidth; }
      function pinta(){
        var max = car.scrollWidth - car.clientWidth - 2;
        if (prev) prev.disabled = car.scrollLeft <= 2;
        if (next) next.disabled = car.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function(){ car.scrollBy({left: -paso(), behavior: quieto ? 'auto' : 'smooth'}); });
      if (next) next.addEventListener('click', function(){ car.scrollBy({left: paso(), behavior: quieto ? 'auto' : 'smooth'}); });
      car.addEventListener('scroll', pinta, {passive: true});
      car.addEventListener('wheel', function(e){
        if (cel() || !e.shiftKey) return;
        var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        if (d) car.scrollLeft += d;
      }, {passive: true});
      window.addEventListener('resize', pinta);
      pinta();
    });
  }

  /* ---------- 5. Botón de la barra fija: usa el de arriba ---------- */
  function botones(){
    document.addEventListener('click', function(e){
      var a = e.target.closest ? e.target.closest('[data-rl-add]') : null; if (!a) return;
      e.preventDefault();
      var main = $('.rl-buy [data-az-add]');
      if (main && !main.disabled){ main.click(); return; }
      var c = $('#rl-colores') || $('.rl-buy [id^="rl-op-"]') || $('.rl-buy');
      if (c) window.scrollTo({top: Math.max(0, c.getBoundingClientRect().top + window.pageYOffset - 90), behavior: quieto ? 'auto' : 'smooth'});
    });
  }

  /* ---------- 6. Encabezado transparente (celular): alto real del encabezado y foto de enfrente ---------- */
  var mq = null, fotoBlanca = false, galPasada = false;
  try { mq = window.matchMedia('(max-width: 899px)'); } catch (e) {}
  function cel(){ return mq ? mq.matches : (html.clientWidth < 900); }
  function altoEncabezado(){
    var hd = $('#header-group .azh');
    if (hd && hd.offsetHeight > 30 && hd.offsetHeight < 240) html.style.setProperty('--rl-hd', hd.offsetHeight + 'px');
  }
  function pintaEncabezado(){ html.classList.toggle('rl-hd-solid', galPasada || (fotoBlanca && cel())); }
  function galeria(){
    var track = $('.rl-buy [data-az-track]'); if (!track) return;
    var slides = track.children, x = track.scrollLeft, k = 0, d = Infinity;
    for (var n = 0; n < slides.length; n++){ var dd = Math.abs(slides[n].offsetLeft - slides[0].offsetLeft - x); if (dd < d){ d = dd; k = n; } }
    fotoBlanca = !!(slides[k] && (slides[k].classList.contains('rl-g__s--prod') || slides[k].classList.contains('rl-g__s--claro')));
    pintaEncabezado();
  }

  /* ---------- 7. Barra fija y encabezado al bajar ----------
     El encabezado es transparente solo mientras está encima de la galería; en cuanto la galería
     queda arriba de su borde de abajo, se pone blanco. Se revisa con cada scroll (sin esperar a
     requestAnimationFrame), con un IntersectionObserver y con un respaldo cada 300 ms, para que
     nunca se quede transparente encima de la compra. */
  function barra(){
    var stk = $('[data-rl-stk]'), cta = $('[data-rl-cta]'), gal = $('.rl-buy .rl-g'), track = $('.rl-buy [data-az-track]');
    var pie = document.querySelector('[id$="__az_footer"]') || document.querySelector('footer');
    var hdEl = $('#header-group .azh');
    var ultimo = '';
    function revisa(){
      var vh = html.clientHeight || window.innerHeight;
      var hdBottom = hdEl ? hdEl.getBoundingClientRect().bottom : 64;
      if (gal){ galPasada = gal.getBoundingClientRect().bottom <= hdBottom + 1; }
      var on = false;
      if (cta){
        var r = cta.getBoundingClientRect();
        var enPie = pie ? pie.getBoundingClientRect().top < vh - 10 : false;
        /* La barra sale en cuanto el botón queda debajo del encabezado (no hasta salir de la pantalla): en fichas cortas también aparece */
        on = !!stk && r.bottom < hdBottom && !enPie && cel();
      }
      var firma = (on ? 1 : 0) + '|' + (galPasada ? 1 : 0);
      if (firma === ultimo) return;
      ultimo = firma;
      if (stk){ stk.classList.toggle('is-on', on); stk.setAttribute('aria-hidden', on ? 'false' : 'true'); var bb = stk.querySelector('button'); if (bb) bb.tabIndex = on ? 0 : -1; }
      html.classList.toggle('rx-stk-on', on);
      pintaEncabezado();
    }
    window.addEventListener('scroll', revisa, {passive: true});
    document.addEventListener('scroll', revisa, {passive: true, capture: true});
    window.addEventListener('resize', function(){ altoEncabezado(); galeria(); ultimo = ''; revisa(); });
    window.addEventListener('pageshow', function(){ ultimo = ''; revisa(); });
    if (hayIO && gal){
      new IntersectionObserver(function(){ ultimo = ''; revisa(); }, {threshold: [0, 0.05, 0.1, 0.2, 0.5, 1]}).observe(gal);
    }
    setInterval(revisa, 300);
    if (track){ track.addEventListener('scroll', galeria, {passive: true}); }
    revisa();
  }

  /* ---------- 8. «Míralo en acción»: ningún video arranca solo ----------
     Nada se descarga ni se reproduce hasta el clic (preload="none" y data-src); solo uno a la vez; arranca sin sonido.
     El botón «Sonido» sale solo mientras se reproduce. Al salir de la pantalla se pausa (nunca se reproduce por scroll). */
  function clips(){
    var cajas = $$('[data-rl-clip]'); if (!cajas.length) return;
    function pausaOtros(yo){ cajas.forEach(function(c){ if (c !== yo){ var o = c.querySelector('video'); if (o && !o.paused) o.pause(); } }); }
    cajas.forEach(function(c){
      if (c.getAttribute('data-rl-ok')) return; c.setAttribute('data-rl-ok', '1');
      var v = c.querySelector('video'), bp = c.querySelector('[data-rl-clip-play]'), bs = c.querySelector('[data-rl-clip-snd]');
      if (!v) return;
      v.muted = true; v.setAttribute('muted', '');
      function pintaSonido(){ if (!bs) return; var on = !v.muted; bs.setAttribute('aria-pressed', on ? 'true' : 'false'); bs.setAttribute('aria-label', on ? 'Quitar el sonido' : 'Activar el sonido'); }
      function arranca(){ if (!v.getAttribute('src')){ v.src = v.getAttribute('data-src'); v.preload = 'auto'; } pausaOtros(c); play(v); }
      if (bp) bp.addEventListener('click', arranca);
      v.addEventListener('click', function(){ if (v.paused) arranca(); else v.pause(); });
      v.addEventListener('play', function(){ c.classList.add('is-play', 'is-on'); if (bs) bs.hidden = false; pausaOtros(c); });
      v.addEventListener('pause', function(){ c.classList.remove('is-play'); if (bs) bs.hidden = true; });
      v.addEventListener('ended', function(){ c.classList.remove('is-play'); if (bs) bs.hidden = true; v.currentTime = 0; });
      if (bs) bs.addEventListener('click', function(e){ e.stopPropagation(); v.muted = !v.muted; if (v.paused) arranca(); pintaSonido(); });
      pintaSonido();
      if (hayIO) new IntersectionObserver(function(en){ en.forEach(function(x){ if (!x.isIntersecting && !v.paused) v.pause(); }); }, {threshold: 0}).observe(c);
    });
  }
  function antes(){
    $$('[data-rl-ad]').forEach(function(box){
      if (box.getAttribute('data-rl-ok')) return; box.setAttribute('data-rl-ok', '1');
      var r = box.querySelector('[data-rl-ad-r]'), arrastra = false, modo = null, x0 = 0, y0 = 0;
      function pon(p){ p = Math.max(0, Math.min(100, p)); box.style.setProperty('--p', p + '%'); if (r) r.value = Math.round(p); }
      function desde(e){ var b = box.getBoundingClientRect(); return (e.clientX - b.left) / b.width * 100; }
      function captura(e){ try { box.setPointerCapture(e.pointerId); } catch (er) {} }
      box.addEventListener('pointerdown', function(e){
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        arrastra = true; x0 = e.clientX; y0 = e.clientY; modo = e.pointerType === 'mouse' ? 'h' : null;
        if (modo === 'h'){ captura(e); pon(desde(e)); }
      });
      box.addEventListener('pointermove', function(e){
        if (!arrastra) return;
        if (modo === null){
          var dx = Math.abs(e.clientX - x0), dy = Math.abs(e.clientY - y0);
          if (dx > 6 && dx > dy){ modo = 'h'; captura(e); } else if (dy > 6){ arrastra = false; return; }
        }
        if (modo === 'h') pon(desde(e));
      });
      function suelta(e){ if (arrastra && modo === null && e && e.type === 'pointerup') pon(desde(e)); arrastra = false; modo = null; }
      box.addEventListener('pointerup', suelta);
      box.addEventListener('pointercancel', suelta);
      if (r) r.addEventListener('input', function(){ pon(parseFloat(r.value) || 0); });
    });
  }

  function init(){ altoEncabezado(); hero(); clips(); antes(); entrega(); fichaGenerica(); agotado(); barra(); galeria(); relacionados(); setTimeout(galeria, 200); }
  color(); botones(); ligas();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function(){ altoEncabezado(); galeria(); });
  document.addEventListener('shopify:section:load', function(){ hero(); clips(); antes(); relacionados(); });
})();
